import React, { Component } from "react";
// import "./NonPoItems.css";
import SideNav from "../sidenav/Sidenav.js";
import { CrfContext } from "../../CrfContext";
import { Redirect } from "react-router-dom";

import { Transition, animated } from "react-spring/renderprops";
import { getData, localValidation, allowNumberInputs } from "./actions";
import DraftView from "./DraftView";

import axios from "axios";
import PoModal from "../poitems/PoModal.js";
import { Button } from "@material-ui/core";
// import NonPoModal from "./NonPoModal";

export class NonPoItems extends Component {
  state = {
    progress: 0,
    releasingCenter: "BDO Examiner",
    isLoadingSubmit: false,
    userDeptList: [],

    showBanner: true,
    showForm: false,
    showPage1: false,
    showPage2: false,

    requestType: "",
    vendor: "",
    vendorError: false,
    vendorErr: 1,
    dueDate: "",
    receivingDate: "",
    termDays: "",
    particulars: "",
    particularsError: false,
    particularsErr: 1,
    requestingDepartment: "",
    poNumber: null,
    poNumberError: false,
    poNumberErr: 1,
    project: "",
    projectError: false,
    projectErr: 1,
    subProject: "",
    file: null,
    fileText: null,
    fileError: false,
    fileErr: 1,
    budgetLineItem: "",

    projectClass: [
      {
        glCategory: "",
        glAccount: "",
        description1: "",
        description2: "",
        itemNumber: "",
        grossPricePerItem: 0,
        netPricePerItem: 0,
        quantity: 1,
        costType: "1OV",
        vatType: "None IVAT-X1",
        vatTypeValue: 1,
        wTax: 0,
        wTaxType: "X1",
        wTaxRate: "0",
        wTaxTypeValue: 0,
        wTaxTypeString: "",
        unitPrice: 0,
        subNetPrice: 0,
        projectClass: "",
        subTotalGrossPrice: 0.0,
        subTotalNetPrice: 0.0,
        classDepartment: "",
      },
    ],
    requestingGrossPrice: 0.0,
    requestingAmount: 0.0,
    glCategory: "",
    projectCode: "",
    vendorLists: [],
    departmentLists: [],
    projectLists: [],
    projectCode: "",
    accountTypes: [],
    itemNoList: [],

    redirect: false,
    crfId: "",

    vendorListEmpty: false,
    updateForm: false,
    advancesProjectClass: [],

    subNetList: [],

    vatTypeSelector: "",
    vatTypeSelected: "",

    wTaxRates: [],

    vendorLists: [],
    projectLists: [],

    cocExpenses: [],
    advances: [],
    ppeAccounts: [],
    adminExpenses: [],
    advancesProjectClass: [],

    error: 0,

    removal: false,
    target: null,
    addProjectClass: false,

    requestId: "",
    budgetLineItemList: [],
    accountCodeAndNameList: [],
  };

  onBlurNumber = (e, index, key) => {
    if (key === "quantity") {
      const projectClass = [...this.state.projectClass];
      const obj = { ...projectClass[index] };
      if (e.target.value === "0" || e.target.value === "") {
        obj[key] = 1;
        projectClass[index] = obj;
        this.setState({
          projectClass,
        });
        return;
      }
    }

    if (key === "grossPricePerItem") {
      const projectClass = [...this.state.projectClass];
      const obj = { ...projectClass[index] };
      if (e.target.value === "") {
        obj[key] = 0;
        projectClass[index] = obj;
        this.setState({
          projectClass,
        });
        return;
      }
    }
  };
  handleWTaxRate = async (wTaxType) => {
    try {
      const { data } = await getData(
        `/api/withHoldingTax/wTaxRate/${wTaxType}`
      );
      return data.Rate;
    } catch (err) {
      return "0";
    }
  };
  projectClassComputation = async (
    qty,
    grossPrice,
    vatType,
    wTaxType,
    projectClass,
    index,
    key
  ) => {
    const data = {
      rate: await this.handleWTaxRate(wTaxType),
    };
    const subTotalGrossPrice =
      (qty === "" ? 1 : parseInt(qty)) *
      parseFloat(grossPrice === "" ? 0 : grossPrice);
    const unitPrice =
      subTotalGrossPrice / (vatType === "None IVAT-X1" ? 1 : 1.12);
    const netWTax = unitPrice * (data.rate * 0.01);
    const subTotalNetPrice = subTotalGrossPrice - netWTax;
    projectClass[index].quantity = qty;
    projectClass[index].grossPricePerItem = grossPrice;
    projectClass[index].vatType = vatType;
    projectClass[index].wTaxType = wTaxType;
    projectClass[index].wTaxRate = data.rate;
    projectClass[index].subTotalGrossPrice = subTotalGrossPrice.toFixed(2);
    projectClass[index].subTotalNetPrice =
      data.rate === "0"
        ? subTotalGrossPrice.toFixed(2)
        : subTotalNetPrice.toFixed(2);

    let requestingGrossPrice = 0.0;
    let requestingAmount = 0.0;
    for (let obj of projectClass) {
      requestingGrossPrice =
        parseFloat(obj.subTotalGrossPrice) + parseFloat(requestingGrossPrice);
      requestingAmount =
        parseFloat(obj.subTotalNetPrice) + parseFloat(requestingAmount);
    }
    this.setState({
      projectClass,
      requestingGrossPrice: requestingGrossPrice.toFixed(2),
      requestingAmount: requestingAmount.toFixed(2),
    });
  };

  onChangedHandler = (event, index, key) => {
    if (key === "poNumber") {
      if (event.target.value.length <= 9) {
        const poNumber = allowNumberInputs(event.target.value);
        this.setState({
          poNumber,
        });
      }
      return;
    }
    if (key === "dueDate") {
      this.setState({
        dueDate: event.target.value,
      });
    }
    if (key === "quantity") {
      const projectClass = [...this.state.projectClass];
      const obj = { ...projectClass[index] };
      if (event.target.value === "0" || event.target.value === " ") {
        obj.quantity = "";
      } else {
        if (event.target.value.length > 9) {
          const qtyCopy = event.target.value.slice(0, -1);
          const quantity = allowNumberInputs(qtyCopy);
        } else {
          const quantity = allowNumberInputs(event.target.value);
          this.projectClassComputation(
            quantity.trim(),
            this.state.projectClass[index].grossPricePerItem,
            this.state.projectClass[index].vatType,
            this.state.projectClass[index].wTaxType,
            projectClass,
            index,
            "quantity"
          );
        }
      }
    }

    this.handleChangeProjectClassValue(event, index, key);
    const projectClassArray = [...this.state.projectClass];
    const projectClassObject = { ...projectClassArray[index] };
    projectClassArray[index] = projectClassObject;
    this.setState({
      projectClass: projectClassArray,
    });
  };

  formatDate = (date) => {
    let d = new Date(date);
    let month = (d.getMonth() + 1).toString();
    let day = d.getDate().toString();
    let year = d.getFullYear();
    if (month.length < 2) {
      month = "0" + month;
    }
    if (day.length < 2) {
      day = "0" + day;
    }
    return [year, month, day].join("-");
  };

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        showForm: true,
      });
    }, 500);
    // === INITIAL VALUE OF DRAFT ==============================================================================================
    axios({
      method: "GET",
      url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm/${this.props.match.params.id}`,
      headers: {
        "Api-Key":
          "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
        Authorization: `Bearer ${localStorage.token}`,
      },
    })
      /**
       * Ganito yon
       * #1 Get depth 1 objects
       * #2 Get depth 2 objects such as @param projectClasses
       * #3 Get data-driven information, e.g. @param vatTypeSelector
       */
      .then((response) => {
        const i = response.data.data;
        this.setState({
          receivingDate: i.receivingDate,
          poNumber: i.poNumber,
          termDays: i.termDays,
          requestingDepartment: i.department,
          dueDate: i.dueDate,
          vendor: i.vendor,
          project: i.project,
          projectClass: i.projectClasses,
          releasingCenter: i.releasingCenter,
          subProject: i.subProject,
          particulars: i.particulars,
          requestType: i.requestType,
          status: i.status,
          requestor: i.requestor,
          supportingDocuments: i.supportingDocuments,
          totalNetPrice: i.totalNetPrice,
          creationDate: i.creationDate,
        });

        this.loadBudgetLineItems(i.project);
        for (let index in i.projectClasses) {
          this.getBudgetLineItemOBJ(index);
          //   
        }
        for (let index in i.projectClasses) {
          this.projectClassComputation(
            i.projectClasses[index].quantity
              ? i.projectClasses[index].quantity
              : 1,
            i.projectClasses[index].grossPricePerItem,
            i.projectClasses[index].vatType,
            i.projectClasses[index].wTaxType,
            i.projectClasses,
            index,
            "key"
          );
        }
        axios({
          method: "GET",
          url: `${process.env.REACT_APP_API_KEY}/api/vendors/${i.vendor}`,
          headers: {
            "Api-Key":
              "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
            Authorization: `Bearer ${localStorage.token}`,
          },
        }).then((response1) => {
          axios({
            method: "GET",
            url: `${process.env.REACT_APP_API_KEY}/api/withHoldingTax/wTaxCode/${response1.data.data.bpCode}`,
            headers: {
              "Api-Key":
                "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
              Authorization: `Bearer ${localStorage.token}`,
            },
          }).then((response2) => {
            let newArray = response2.data.data;
            const none = {
              wTaxCode: "X1",
              wTaxName: "",
              wTaxDisplayName: "None ",
              rate: "0",
            };
            newArray.push(none);
            this.setState({
              vatTypeSelector: response1.data.data.vatType,
              wTaxRates: newArray,
            });
          });
        });
      })
      .catch((error) => {
          
      });

    // ==== END OF INITIAL VALUE ==================================================================================================
    // ===================================================================
    // GET VENDOR LIST
    axios({
      method: "GET",
      url: `${process.env.REACT_APP_API_KEY}/api/vendors`,
      headers: {
        "Api-Key":
          "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
        Authorization: `Bearer ${localStorage.token}`,
      },
    })
      .then((response) => {
        // document.getElementById('main').style.display = 'block'
        //   
        this.setState({
          vendorLists: response.data.data,
        });
        //   
      })
      .catch((error) => {
          
      });

    //================================================================================

    // GET PROJECT LIST
    axios({
      method: "GET",
      url: `${process.env.REACT_APP_API_KEY}/api/projects`,
      headers: {
        "Api-Key":
          "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
        Authorization: `Bearer ${localStorage.token}`,
      },
    })
      .then((response) => {
        //   
        this.setState({
          projectLists: response.data.data,
        });
      })
      .catch((error) => {
          
      });
    // =========================================================

    axios({
      method: "GET",
      url: `${process.env.REACT_APP_API_KEY}/api/userInfo`,
      headers: {
        "Api-Key":
          "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
        Authorization: `Bearer ${localStorage.token}`,
      },
    })
      .then((response) => {
        //   
        this.setState({
          // userRole: response.data.data.roles[0],
          // userName: response.data.data.firstName
          //  + " " + response.data.data.lastName,
          // userId: response.data.data._id
          userDeptList: response.data.data.departments,
        });
      })
      .catch((error) => {
          
      });

    // ============================================================================
    //

    //=========================================================================================
    // =========================================================================================
  }
  getBudgetLineItemOBJ(index) {
    if (!this.state.projectClass[index]["glCategory"]) return;
    let [accCode, accName] = [
      this.state.projectClass[index]["glAccount"].slice(0, 10),
      this.state.projectClass[index]["glAccount"].slice(10),
    ];
    let bli = this.state.projectClass[index]["glCategory"];
    axios({
      method: "POST",
      url: `${process.env.REACT_APP_API_KEY}/api/budgetLineItem`,
      headers: {
        "Api-Key":
          "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
        Authorization: `Bearer ${localStorage.token}`,
      },
      data: {
        budgetLineItem: bli,
        accountCode: accCode,
        accountName: accName,
      },
    })
      .then((response) => {
        //   
        //   
        if (!response) return;
        let list1 = [],
          list2 = [];
        for (let obj of response.data) {
          list1.push(obj.budgetLineItem);
          list2.push(`${obj.accountCode} / ${obj.accountName}`);
        }
        this.setState({
          budgetLineItemList: list1,
          accountCodeAndNameList: list2,
        });
      })
      .catch((error) => {
          
      });
  }
  checkStateValue = (e) => {
    e.preventDefault();
  };

  loadBudgetLineItems = (project) => {
    this.setState({
      accountTypes: [],
    });
    axios({
      method: "GET",
      url: `${process.env.REACT_APP_API_KEY}/api/projects/${project}`,
      headers: {
        "Api-Key":
          "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
        Authorization: `Bearer ${localStorage.token}`,
      },
    })
      .then((response) => {
        if (this.state.requestingDepartment) {
          const params = {
            projectCode: response.data.data.projectCode,
            department: this.state.requestingDepartment,
          };
          axios({
            method: "POST",
            url: `${process.env.REACT_APP_API_KEY}/api/budgetLineItem/dropdown`,
            headers: {
              "Api-Key":
                "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
              Authorization: `Bearer ${localStorage.token}`,
            },
            data: params,
          })
            .then((response) => {
              let budgetLineItem = response.data.data;
              this.setState({
                accountTypes: budgetLineItem,
              });
            })
            .catch((error) => {
                
              this.setState({
                accountTypes: [],
              });
            });
        }
      })
      .catch((error) => {
          
      });
  };

  // END OF COMPONENT DID MOUNT
  handleChangeRequestField = (e) => {
    e.preventDefault();
    if (e.target.name === "releasingCenter") {
      this.setState({ releasingCenter: e.target.value });
    }
    if (e.target.name === "vendor") {
      this.setState({ vendorError: true });
      axios({
        method: "GET",
        url: `${process.env.REACT_APP_API_KEY}/api/vendors/${e.target.value}`,
        headers: {
          "Api-Key":
            "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
          Authorization: `Bearer ${localStorage.token}`,
        },
      })
        .then((response) => {
          this.setState({
            vatTypeSelector: response.data.data.vatType,
          });
          // ==================================================================================
          // VENDOR BP CODE WILL GET THE WTAX

          axios({
            method: "GET",
            url: `${process.env.REACT_APP_API_KEY}/api/withHoldingTax/wTaxCode/${response.data.data.bpCode}`,
            headers: {
              "Api-Key":
                "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
              Authorization: `Bearer ${localStorage.token}`,
            },
          })
            .then((response) => {
              //   
              let newArray = response.data.data;
              const none = {
                wTaxCode: "X1",
                wTaxName: "",
                wTaxDisplayName: "None ",
                rate: "0",
              };
              newArray.push(none);
              this.setState({
                wTaxRates: newArray,
              });
              //   
            })
            .catch((error) => {
                
            });

          // ==================================================================================
        })
        .catch((error) => {
            
        });

      if (
        !this.state.vendorLists.includes(
          document.getElementById(`${e.target.id}`).value
        )
      ) {
        document.getElementById(
          `${e.target.id}`
        ).nextElementSibling.nextElementSibling.children[0].innerText =
          "Invalid Input";
        document.getElementById(
          `${e.target.id}`
        ).nextElementSibling.nextElementSibling.children[1].innerText =
          " " + "(Please input a valid data included in the list)";
        this.setState({ vendorErr: 1 });
      } else {
        document.getElementById(
          `${e.target.id}`
        ).nextElementSibling.nextElementSibling.children[0].innerText = "";
        document.getElementById(
          `${e.target.id}`
        ).nextElementSibling.nextElementSibling.children[1].innerText = "";
        this.setState({ vendorErr: 0 });
      }

      const newProjecClasses = this.state.projectClass;
      for (let i = 0; i < newProjecClasses.length; i++) {
        //   
        if (this.state.wTaxRates.length === 1) {
          newProjecClasses[i].wTaxType = "X1";
        } else {
          newProjecClasses[i].vatType = "None IVAT-X1";
          newProjecClasses[i].wTaxType = "X1";
        }

        document.getElementsByClassName("vatTypeInitialValue")[i].innerText =
          "Please Choose";
      }

      this.setState({
        projectClass: newProjecClasses,
      });
    }
    if (e.target.name === "receivingDate") {
      this.setState({ receivingDate: e.target.value });
      if (this.state.termDays) {
        const date = new Date(this.state.receivingDate);
        date.setDate(date.getDate() + parseInt(this.state.termDays));
        this.setState({
          dueDate: this.formatDate(date),
        });
      }
    }
    if (e.target.name === "termDays") {
      if (e.target.value < 0) {
        alert("Enter positive numbers only!");
      } else {
        this.setState({ termDays: e.target.value });
        if (this.state.receivingDate) {
          const date = new Date(this.state.receivingDate);
          date.setDate(date.getDate() + parseInt(this.state.termDays));
          this.setState({
            dueDate: this.formatDate(date),
          });
        }
      }
    }
    if (e.target.name === "particulars") {
      this.setState({
        particulars: e.target.value,
      });
      this.setState({ particularsError: true });
      if (e.target.value === "") {
        this.setState({ particularsErr: 1 });
      } else {
        this.setState({ particularsErr: 0 });
      }
    }
    if (e.target.name === "requestingDepartment") {
      const copyOfProjectClass = [...this.state.projectClass];
      const projectObj = { ...copyOfProjectClass[0] };
      projectObj.classDepartment = e.target.value;
      copyOfProjectClass[0] = projectObj;
      this.setState({
        requestingDepartment: e.target.value,
        projectClass: copyOfProjectClass,
      });
    }
    if (e.target.name === "project") {
      for (let i = 0; i < this.state.projectClass.length; i++) {
        this.setState(() => (this.state.projectClass[i].glCategory = ""));
      }
      // ================================================================================================
    }

    if (e.target.name === "file" && e.target.files.length !== 0) {
      let fileName = e.target.files[0].name.split(".");
      let fileExtension = fileName[fileName.length - 1];
      //   
      this.setState({ fileError: true });
      //   
      //   
      if (fileExtension !== "pdf") {
        this.setState({ fileErr: 1 });
      } else {
        this.setState({
          fileErr: 0,
          fileText: fileName[0],
          file: e.target.files[0],
        });
        //   
      }
    }

    // GET THE PARTICULAR VAT TYPE FOR SELECTED VENDOR

    // ================================================================

    // this.setState({
    //   [e.target.name]: e.target.value,
    //   requestingDepartment: document.getElementById("departmentInput").value
    // })
    // this.setState(()=> this.state.(e.target.name) = e.target.value)

    // CHANGE GL CATEGORY SELECTIONS
    // for (let i = 0; i < glCategoryClass.length; i++) {
    //   //   
    //   glCategoryClass[i].value = ""
    //   this.setState(()=> this.state.projectClass[i].glCategory = "")
    // }

    if (e.target.name === "project") {
      this.setState({
        accountTypes: [],
        project: e.target.value,
      });
      axios({
        method: "GET",
        url: `${process.env.REACT_APP_API_KEY}/api/projects/${e.target.value}`,
        headers: {
          "Api-Key":
            "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
          Authorization: `Bearer ${localStorage.token}`,
        },
      })
        .then((response) => {
          ////   
          this.setState({
            projectCode: response.data.data.projectCode,
          });
          ////   
          if (this.state.requestingDepartment) {
            const params = {
              projectCode: response.data.data.projectCode,
              department: this.state.requestingDepartment,
            };
            axios({
              method: "POST",
              url: `${process.env.REACT_APP_API_KEY}/api/budgetLineItem/dropdown`,
              headers: {
                "Api-Key":
                  "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
                Authorization: `Bearer ${localStorage.token}`,
              },
              data: params,
            })
              .then((response) => {
                ////   
                let budgetLineItem = response.data.data;
                //   
                this.setState({
                  accountTypes: budgetLineItem,
                });
              })
              .catch((error) => {
                  
                this.setState({
                  accountTypes: [],
                });
              });
          }
        })
        .catch((error) => {
            
        });
    }
    //file error
    // if (e.target.name === "file" && e.target.files.length !== 0) {
    //   let fileName = e.target.files[0].name.split(".");
    //   let fileExtension = fileName[fileName.length - 1];
    //   fileExtension !== "pdf"
    //     ? (document.getElementById("documentEmptyError").innerText =
    //         "(Please upload a valid file(pdf).)")
    //     : (document.getElementById("documentEmptyError").innerText = "");
    // }
    //   

    this.setState({
      error:
        this.state.vendorErr +
        this.state.particularsErr +
        this.state.projectErr +
        this.state.fileErr,
    });
    //   
  };

  // =============================

  handleChangeProjectClassValue = (e, index, key) => {
    let projectClassCopy = [...this.state.projectClass];
    if (e.target.name === "classDepartment") {
      projectClassCopy[parseInt(e.target.id)][e.target.name] = e.target.value;
      this.setState({ projectClass: projectClassCopy });
    }
    if (
      e.target.name === "glCategory" ||
      e.target.name === "glAccount" ||
      e.target.name === "projectClass" ||
      e.target.name === "itemCode"
    ) {
      if (e.target.name === "glCategory") {
        const json = JSON.parse(e.target.value);
        projectClassCopy[parseInt(e.target.id)].glCategory =
          json.budgetLineItem;
      } else {
        projectClassCopy[parseInt(e.target.id)][e.target.name] = e.target.value;
      }
      this.setState({ projectClass: projectClassCopy });
    }
    if (key === "description1" || key === "description2") {
      projectClassCopy[index][key] = e.target.value.trimLeft();
      this.setState({ projectClass: projectClassCopy });
    }
    if (key === "itemCode") {
      projectClassCopy[index][key] = e.target.value.trimRight();
      this.setState({ projectClass: projectClassCopy });
    }

    if (e.target.name === "grossPricePerItem") {
      const grossPrice = e.target.value.split(".");
      if (grossPrice[0].length <= 12) {
        // projectClassCopy[parseInt(e.target.id)][e.target.name] = e.target.value
        // this.setState({projectClass: projectClassCopy})
        this.projectClassComputation(
          1,
          e.target.value,
          this.state.projectClass[index].vatType,
          this.state.projectClass[index].wTaxType,
          projectClassCopy,
          index,
          "grossPricePerItem"
        );
      }
    }
    if (e.target.name === "vatType") {
      this.projectClassComputation(
        1,
        this.state.projectClass[index].grossPricePerItem,
        e.target.value,
        this.state.projectClass[index].wTaxType,
        projectClassCopy,
        index,
        "vatType"
      );
    }

    if (e.target.name === "wTaxType") {
      this.projectClassComputation(
        1,
        this.state.projectClass[index].grossPricePerItem,
        this.state.projectClass[index].vatType,
        e.target.value,
        projectClassCopy,
        index,
        "wTaxType"
      );
    }

    // EXTRACT GL ACCOUNT NAME

    // CHANGE GL NAME LISTS

    if (e.target.name === "glCategory") {
      const value = JSON.parse(e.target.value);
      projectClassCopy[
        parseInt(e.target.id)
      ].glAccount = `${value.accountCode} ${value.accountName}`;
      projectClassCopy[parseInt(e.target.id)].budgetLineItem =
        value.budgetLineItem;
      this.setState({
        projectClass: projectClassCopy,
      });
    }
    if (e.target.name === "projectClass") {
      projectClassCopy[parseInt(e.target.id)].projectClass = e.target.value;
    }
  };

  addProjectClass = (e) => {
    e.preventDefault();
    this.setState({
      addedProjectClass: true,
      projectClass: [
        ...this.state.projectClass,
        {
          glCategory: "",
          glAccount: "",
          description1: "",
          description2: "",
          itemNumber: "",
          grossPricePerItem: 0,
          netPricePerItem: 0,
          quantity: 1,
          costType: "1OV",
          vatType: "None IVAT-X1",
          vatTypeValue: 1,
          wTax: 0,
          wTaxType: "X1",
          wTaxRate: "0",
          wTaxTypeValue: 0,
          wTaxTypeString: "",
          unitPrice: 0,
          subNetPrice: 0,
          projectClass: "",
          subTotalGrossPrice: "0.00",
          subTotalNetPrice: "0.00",
          classDepartment: this.state.requestingDepartment, //this.state.userDeptList[0]?.centerName
        },
      ],
    });
    // this.state.projectClass.push(
    //   {
    //           glCategory: "",
    //           glAccount: "",
    //           description1: "",
    //           description2: "",
    //           itemNumber: "",
    //           grossPricePerItem: 0,
    //           netPricePerItem: 0,
    //           quantity: 1,
    //           costType: "1OV",
    //           vatType: "",
    //           vatTypeValue: 1,
    //           wTax: 0,
    //           wTaxType:"X1",
    //           wTaxTypeValue: 0,
    //           wTaxTypeString: "",
    //           unitPrice: 0,
    //           subNetPrice: 0,
    //           projectClass: ""
    //         }
    // )
  };

  handleSubmitNonPo = async (e, key) => {
    //   
    e.preventDefault();
    this.setState({ isLoading: true });
    let array = this.state.projectClass;

    const updateProgress = (progressState) => {
      this.setState({ progress: progressState });
    };
    const config = {
      onUploadProgress: function (progressEvent) {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        updateProgress(percentCompleted);
      },
    };

    let formData = new FormData();

    let nonPoForm = {
      receivingDate: this.state.receivingDate,
      termDays: this.state.termDays,
      dueDate: this.state.dueDate,
      department: this.state.requestingDepartment,
      vendor: this.state.vendor,
      project: this.state.project,
      projectClasses: this.state.projectClass,
      releasingCenter: this.state.releasingCenter,
      subProject: this.state.subProject,
      particulars: this.state.particulars,
      requestType: "Non PO Item",
      status: "For Approval",
    };

    //validate to view loading
    const fieldToValidate = localValidation(nonPoForm);
    if (fieldToValidate !== null) {
      this.setState({ isLoading: false });
      alert(`${fieldToValidate} is required`);
      return "remainOnFirstPage";
    } else {
      const vendor = await getData(`/api/vendors/${nonPoForm.vendor}`);
      const project = await getData(`/api/projects/${nonPoForm.project}`);
      if (vendor.data === null) {
        this.setState({ isLoading: false });
        alert("Please make sure that the vendor is valid");
        return "remainOnFirstPage";
      }
      if (project.data === null) {
        this.setState({ isLoading: false });
        alert("Please make sure that the project is valid");
        return "remainOnFirstPage";
      }
      if (this.state.file === null || this.state.fileErr === 1) {
        this.setState({ isLoading: false });
        alert("Supporting documents is required");
        return "remainOnFirstPage";
      }
      if (key === "fromFirstPage") {
        this.setState({ isLoading: false });
        return;
      }
      const validationProjectClasses = await this.localValidationProjectClasses(
        nonPoForm.projectClasses
      );
      if (validationProjectClasses) {
        this.setState({ isLoading: false });
        return;
      }
      document.getElementById("modalBody").style.display = "block";
    }

    formData.set("crfForm", JSON.stringify(nonPoForm));
    formData.append("supportingDocuments", this.state.file);

    axios({
      method: "POST",
      url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm`,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
        "Api-Key":
          "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
        Authorization: `Bearer ${localStorage.token}`,
      },
      onUploadProgress: config.onUploadProgress,
    })
      .then((response) => {
        this.setState({
          isLoading: false,
          redirect: true,
          crfId: `/CheckRequest/${response.data.Data._id}`,
        });
        document.getElementById("modalBody").style.display = "none";
      })
      .catch((error) => {
        this.setState({ isLoading: false });
        alert("Please complete the fields before submitting");
        document.getElementById("formHintContainer").style.display = "block";
        document.getElementById("modalBody").style.display = "none";
        document.getElementById("errorHint").innerText =
          " " +
          "Please make sure you filled up the required fields at Project Class" +
          " " +
          (parseInt(error.response.data.Error.slice(-1)) + 1);
        // document.getElementById("form-validation-error").innerText = "Please fill out the required fields or check if your input is correct"
      });
  };

  handleDraftNonPo = (e) => {
    //   

    e.preventDefault();
    const updateProgress = (progressState) => {
      this.setState({ progress: progressState });
    };
    const config = {
      onUploadProgress: function (progressEvent) {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        updateProgress(percentCompleted);
      },
    };

    let array = this.state.projectClass;
    let formData = new FormData();
    const newProjectClass = [];
    //x
    // alert(this.state.file);
    let nonPoForm = {
      receivingDate: this.state.receivingDate,
      termDays: this.state.termDays,
      dueDate: this.state.dueDate,
      poNumber: this.state.poNumber,
      vendor: this.state.vendor,
      department: this.state.requestingDepartment,
      particulars: this.state.particulars,
      releasingCenter: this.state.releasingCenter,
      project: this.state.project,
      subProject: this.state.subProject,
      projectClasses: this.state.projectClass,
      requestingGrossPrice: this.state.requestingGrossPrice,
      requestingAmount: this.state.requestingAmount,
      id: this.props.match.params.id,
    };
    formData.set("crfForm", JSON.stringify(nonPoForm));
    formData.append("supportingDocuments", this.state.file);
    //   
    document.getElementById("modalBody").style.display = "block";
    axios({
      method: "PUT",
      url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm/draft/${this.props.match.params.id}`,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
        "Api-Key":
          "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
        Authorization: `Bearer ${localStorage.token}`,
      },
      onUploadProgress: config.onUploadProgress,
    })
      .then((response) => {
        if (response.data.data === "Successfully updated CRF Form") {
          window.location.reload();
        }
      })
      .catch((error) => {
          
      });
  };

  handleRemoveProjectClass = (e, index) => {
    e.preventDefault();
    const projectClass = [...this.state.projectClass];
    projectClass.splice(index, 1);
    let requestingGrossPrice = 0.0;
    let requestingAmount = 0.0;
    for (let obj of projectClass) {
      requestingGrossPrice =
        parseFloat(obj.subTotalGrossPrice) + parseFloat(requestingGrossPrice);
      requestingAmount =
        parseFloat(obj.subTotalNetPrice) + parseFloat(requestingAmount);
    }
    this.setState({
      projectClass,
      requestingGrossPrice: requestingGrossPrice.toFixed(2),
      requestingAmount: requestingAmount.toFixed(2),
    });
  };

  localValidationProjectClasses = async (projectClasses, requestType) => {
    let validationRemarks = null;
    let countIndex = 0;
    for (const obj of projectClasses) {
      countIndex = countIndex + 1;
      if (obj.glCategory === "") {
        alert(`Project class ${countIndex}: glCategory is required`);
        validationRemarks = "Failed";
        break;
      }
      if (obj.glCategory === "AdvancesFromOtherCRIS") {
        if (!obj.projectClass) {
          alert(`Project class ${countIndex}: Project class is required`);
          validationRemarks = "Failed";
          break;
        }
        const { data } = await getData(
          `/api/projectClasses/${obj.projectClass}`
        );
        //   
        if (data === null) {
          alert(
            `Project class ${countIndex}: Please make sure that the project class is valid`
          );
          validationRemarks = "Failed";
          break;
        }
      }
      if (obj.glAccount === "") {
        alert(`Project class ${countIndex}: glAccount is required`);
        validationRemarks = "Failed";
        break;
      }
      if (requestType === "PO Item") {
        if (!obj.itemCode) {
          alert(`Project class ${countIndex}: itemNo is required`);
          validationRemarks = "Failed";
          break;
        }
        if (obj.itemCode) {
          const { data } = await getData(`/api/itemNo/${obj.itemCode}`);
          if (data === null) {
            alert(
              `Project class ${countIndex}: Please make sure that the item number is valid`
            );
            validationRemarks = "Failed";
            break;
          }
        }
      }
      if (obj.description1 === "") {
        alert(`Project class ${countIndex}: description 1 is required`);
        validationRemarks = "Failed";
        break;
      }
      if (obj.grossPricePerItem === 0) {
        alert(`Project class ${countIndex}: gross price is required`);
        validationRemarks = "Failed";
        break;
      }
      if (obj.vatType === "") {
        alert(`Project class ${countIndex}: vatType is required`);
        validationRemarks = "Failed";
        break;
      }
      if (obj.wTaxType === "") {
        alert(`Project class ${countIndex}: wTaxType is required`);
        validationRemarks = "Failed";
        break;
      }
    }
    return validationRemarks;
  };

  handleSubmitDraft = async (e, key) => {
    e.preventDefault();

    if (key === "fromFirstPage") {
      const copyOfProjectClass = [...this.state.projectClass];
      const projectObj = { ...copyOfProjectClass[0] };
      projectObj.classDepartment = this.state.requestingDepartment;
      copyOfProjectClass[0] = projectObj;
      this.setState({ projectClass: copyOfProjectClass });
    }

    this.setState({ isLoadingSubmit: true });
    //   
    let array = this.state.projectClass;

    const updateProgress = (progressState) => {
      this.setState({ progress: progressState });
    };
    const config = {
      onUploadProgress: function (progressEvent) {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        updateProgress(percentCompleted);
      },
    };

    let formData = new FormData();
    const newProjectClass = [];
    if (this.state.requestType === "PO Item") {
      // if(this.state.poNumber === null || this.state.poNumber === ""){
      //   document.getElementById('formHintContainer').style.display = "block"
      //   document.getElementById('draftErrorHint').innerText = "PO number is required."
      // }else{
      let nonPoForm = {
        // status: "For Approval",
        // vendor: this.state.vendor,
        // department: this.state.requestingDepartment,
        // particulars: this.state.particulars,
        // project: this.state.project,
        // subProject: this.state.subProject,
        // projectClasses: this.state.projectClass
        dueDate: this.state.dueDate,
        poNumber: this.state.poNumber,
        department: this.state.requestingDepartment,
        vendor: this.state.vendor,
        project: this.state.project,
        releasingCenter: this.state.releasingCenter,
        projectClasses: this.state.projectClass,
        subProject: this.state.subProject,
        particulars: this.state.particulars,
        status: "For Approval",
      };
      const fieldToValidate = localValidation(nonPoForm);
      if (fieldToValidate !== null) {
        alert(`${fieldToValidate} is required`);
        this.setState({ isLoadingSubmit: false });
        return "remainOnFirstPage";
      } else {
        const vendor = await getData(`/api/vendors/${nonPoForm.vendor}`);
        const project = await getData(`/api/projects/${nonPoForm.project}`);
        //   
        //   
        if (nonPoForm.poNumber.length !== 9 || nonPoForm.poNumber[0] !== "1") {
          alert("PO number must be 9 digits and should start with number 1");
          this.setState({ isLoadingSubmit: false });
          return "remainOnFirstPage";
        }
        if (vendor.data === null) {
          alert("Please make sure that the vendor is valid");
          this.setState({ isLoadingSubmit: false });
          return "remainOnFirstPage";
        }
        if (project.data === null) {
          alert("Please make sure that the project is valid");
          this.setState({ isLoadingSubmit: false });
          return "remainOnFirstPage";
        }
        if (this.state.file === null || this.state.fileErr === 1) {
          const crf = await getData(
            `/api/checkRequestForm/${this.props.match.params.id}`
          );
          const { supportingDocuments } = crf.data;
          if (!supportingDocuments) {
            alert("Supporting documents is required");
            this.setState({ isLoadingSubmit: false });
            return "remainOnFirstPage";
          }
        }
        if (key === "fromFirstPage") {
          this.setState({ isLoadingSubmit: false });
          return;
        }
        const validationProjectClasses =
          await this.localValidationProjectClasses(
            nonPoForm.projectClasses,
            "PO Item"
          );
        if (validationProjectClasses) {
          this.setState({ isLoadingSubmit: false });
          return;
        }
        document.getElementById("modalBody").style.display = "block";
      }

      formData.set("crfForm", JSON.stringify(nonPoForm));
      formData.append("supportingDocuments", this.state.file);

      this.setState({ isLoadingSubmit: true });
      axios({
        method: "PUT",
        url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm/reSubmit/${this.props.match.params.id}`,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "Api-Key":
            "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
          Authorization: `Bearer ${localStorage.token}`,
        },
        onUploadProgress: config.onUploadProgress,
      })
        .then((response) => {
          document.getElementById("modalBody").style.display = "none";
          //   
          this.setState({
            redirect: true,
            crfId: `/CheckRequest/${this.props.match.params.id}`,
          });
          this.setState({ isLoadingSubmit: false });
          //   
        })
        .catch((error) => {
          document.getElementById("modalBody").style.display = "none";
          this.setState({ isLoadingSubmit: false });
            
          alert(error.response.data.Error);
          document.getElementById("formHintContainer").style.display = "block";
          document.getElementById("draftErrorHint").innerText =
            " " +
            "Please make sure you filled up the required fields at Project Class" +
            " " +
            (parseInt(error.response.data.Error.slice(-1)) + 1);
        });
      // }
    } else {
      let nonPoForm = {
        // status: "For Approval",
        // vendor: this.state.vendor,
        // department: this.state.requestingDepartment,
        // particulars: this.state.particulars,
        // project: this.state.project,
        // subProject: this.state.subProject,
        // projectClasses: this.state.projectClass
        dueDate: this.state.dueDate,
        department: this.state.requestingDepartment,
        vendor: this.state.vendor,
        project: this.state.project,
        releasingCenter: this.state.releasingCenter,
        projectClasses: this.state.projectClass,
        subProject: this.state.subProject,
        particulars: this.state.particulars,
        status: "For Approval",
      };

      const fieldToValidate = localValidation(nonPoForm);
      //   
      if (fieldToValidate !== null) {
        alert(`${fieldToValidate} is required`);
        this.setState({ isLoadingSubmit: false });
        return "remainOnFirstPage";
      } else {
        const vendor = await getData(`/api/vendors/${nonPoForm.vendor}`);
        const project = await getData(`/api/projects/${nonPoForm.project}`);
        if (vendor.data === null) {
          alert("Please make sure that the vendor is valid");
          this.setState({ isLoadingSubmit: false });
          return "remainOnFirstPage";
        }
        if (project.data === null) {
          alert("Please make sure that the project is valid");
          this.setState({ isLoadingSubmit: false });
          return "remainOnFirstPage";
        }
        if (this.state.file === null || this.state.fileErr === 1) {
          const crf = await getData(
            `/api/checkRequestForm/${this.props.match.params.id}`
          );
          const { supportingDocuments } = crf.data;
          if (!supportingDocuments) {
            alert("Supporting documents is required");
            this.setState({ isLoadingSubmit: false });
            return "remainOnFirstPage";
          }
        }
        if (key === "fromFirstPage") {
          this.setState({ isLoadingSubmit: false });
          return;
        }
        const validationProjectClasses =
          await this.localValidationProjectClasses(
            nonPoForm.projectClasses,
            "Non PO Item"
          );
        if (validationProjectClasses) {
          this.setState({ isLoadingSubmit: false });
          return;
        }
        document.getElementById("modalBody").style.display = "block";
      }

      formData.set("crfForm", JSON.stringify(nonPoForm));
      formData.append("supportingDocuments", this.state.file);

      axios({
        method: "PUT",
        url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm/reSubmit/${this.props.match.params.id}`,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "Api-Key":
            "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
          Authorization: `Bearer ${localStorage.token}`,
        },
        onUploadProgress: config.onUploadProgress,
      })
        .then((response) => {
          document.getElementById("modalBody").style.display = "none";
          //   
          this.setState({
            isLoadingSubmit: false,
            redirect: true,
            crfId: `/CheckRequest/${this.props.match.params.id}`,
          });
          //   
        })
        .catch((error) => {
          document.getElementById("modalBody").style.display = "none";
          this.setState({ isLoadingSubmit: false });
            
          if (error.response.data.Error === "projectClass code doesnt exist") {
            document.getElementById("formHintContainer").style.display =
              "block";
            document.getElementById("draftErrorHint").innerText =
              "You have inputed an invalid Project Class value.";
          }
        });
    }
  };

  handleDownloadPdf = () => {
    axios(
      `${process.env.REACT_APP_API_KEY}/api/uploads/${this.props.match.params.id}`,
      {
        method: "GET",
        responseType: "blob",
        headers: {
          "Api-Key":
            "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
          Authorization: `Bearer ${localStorage.token}`,
        },
        //Force to receive data in a Blob Format
      }
    )
      .then((response) => {
        //Create a Blob from the PDF Stream
        const file = new Blob([response.data], {
          type: "application/pdf",
        });
        //Build a URL from the file
        const fileURL = URL.createObjectURL(file);
        //Open the URL on new Window
        window.open(fileURL);
      })
      .catch((error) => {
          
      });
  };

  handleNavigateBack = (id) => {
    setTimeout(() => {
      this.props.history.push({
        pathname: "/Drafts",
        state: { draftId: id },
      });
    }, 2000);
  };

  render() {
    //   

    let vatTypeSelections = "";
    if (this.state.vatTypeSelector == "") {
      vatTypeSelections = (
        <>
          {/* <option value="" disabled selected hidden>Please Choose...</option> */}
          <option value="None IVAT-X1">None IVAT-X1</option>
          <option value="Goods IVAT-G">Goods IVAT-G</option>
          <option value="Services IVAT-S">Services IVAT-S</option>
        </>
      );
    } else if (this.state.vatTypeSelector == "IVAT-G") {
      vatTypeSelections = (
        <>
          {/* <option value="" disabled selected hidden>Please Choose...</option> */}
          <option value="None IVAT-X1">None IVAT-X1</option>
          <option value="Goods IVAT-G">Goods IVAT-G</option>
        </>
      );
      // for (let i = 0; i < this.state.projectClass.length; i++) {
      //   this.state.projectClass[i].vatType = "Goods IVAT-G"
      // }
      //   
    } else if (this.state.vatTypeSelector == "IVAT-S") {
      vatTypeSelections = (
        <>
          {/* <option value="" disabled selected hidden>Please Choose...</option> */}
          <option value="None IVAT-X1">None IVAT-X1</option>
          <option value="Services IVAT-S">Services IVAT-S</option>
        </>
      );
      // for (let i = 0; i < this.state.projectClass.length; i++) {
      //   this.state.projectClass[i].vatType = "Services IVAT-S"
      // }
      //   
    } else if (
      this.state.vatTypeSelector == "X1" ||
      this.state.vatTypeSelector == "IVAT-X" ||
      this.state.vatTypeSelector == "VAT-X"
    ) {
      vatTypeSelections = (
        <>
          <option value="None IVAT-X1">None IVAT-X1</option>
        </>
      );
      for (let i = 0; i < this.state.projectClass.length; i++) {
        this.state.projectClass[i].vatType = "None IVAT-X1";
      }
      //   
    } else {
      vatTypeSelections = (
        <>
          {/* <option value="" disabled selected hidden>Please Choose...</option> */}
          <option value="None IVAT-X1">None IVAT-X1</option>
          <option value="Services IVAT-S">Services IVAT-S</option>
        </>
      );
    }
    if (this.state.redirect === true) {
      return <Redirect to={this.state.crfId} />;
    }

    return (
      // <CrfContext.Consumer>
      //   {(context) => (
      <form id="mainPage">
        <PoModal progress={this.state.progress} />
        <div id="sidePanel">
          <SideNav
          // testState = {context.state.testState}
          // toggleBtn1List = {context.toggleBtn1List}
          // toggleBtn2List = {context.toggleBtn2List}
          // btn1List = {context.state.btn1List}
          // btn2List = {context.state.btn2List}
          // userRole = {context.state.userRole}
          />
        </div>
        <div id="mainPanel">
          {/* BANNER */}
          <Transition
            native
            items={this.state.showBanner}
            from={{ opacity: 0, marginTop: -500 }}
            enter={{ opacity: 1, marginTop: 0 }}
            leave={{ opacity: 0, marginTop: -500 }}
            // config={{ duration: 1000 }}
          >
            {(show) =>
              show &&
              ((props) => (
                <animated.div style={props}>
                  <div className="requestFormBanner">
                    <h1>DRAFT: {this.state.requestType}</h1>
                  </div>
                </animated.div>
              ))
            }
          </Transition>
          {/* END OF BANNER */}
          {/* FORM */}
          <div className="formContainer">
            <Transition
              native
              items={this.state.showForm}
              from={{ opacity: 0 }}
              enter={{ opacity: 1 }}
              leave={{ opacity: 0 }}
              config={{ duration: 300 }}
            >
              {(show) =>
                show &&
                ((props) => (
                  <animated.div style={props}>
                    <DraftView
                      budgetLineItemList={this.state.budgetLineItemList}
                      accountCodeAndNameList={this.state.accountCodeAndNameList}
                      getBudgetLineItemOBJ={this.getBudgetLineItemOBJ}
                      loadBudgetLineItems={this.loadBudgetLineItems}
                      releasingCenter={this.state.releasingCenter}
                      isLoading={this.state.isLoadingSubmit}
                      receivingDate={this.state.receivingDate}
                      termDays={this.state.termDays}
                      dueDate={this.state.dueDate}
                      requestingGrossPrice={this.state.requestingGrossPrice}
                      requestingAmount={this.state.requestingAmount}
                      handleDownloadPdf={this.handleDownloadPdf}
                      requestType={this.state.requestType}
                      fileText={this.state.supportingDocuments}
                      cocExpenses={this.state.cocExpenses}
                      advances={this.state.advances}
                      ppeAccounts={this.state.ppeAccounts}
                      adminExpenses={this.state.adminExpenses}
                      advancesProjectClass={this.state.advancesProjectClass}
                      userDeptList={this.state.userDeptList}
                      requestingDepartment={this.state.requestingDepartment}
                      poNumber={this.state.poNumber}
                      vendor={this.state.vendor}
                      vendorError={this.state.vendorError}
                      budgetLineItem={this.state.budgetLineItem}
                      vendorErr={this.state.vendorErr}
                      particulars={this.state.particulars}
                      particularsError={this.state.particularsError}
                      particularsErr={this.state.particularsErr}
                      project={this.state.project}
                      projectError={this.state.projectError}
                      projectErr={this.state.projectErr}
                      file={this.state.file}
                      fileError={this.state.fileError}
                      fileErr={this.state.fileErr}
                      subProject={this.state.subProject}
                      projectClass={this.state.projectClass}
                      accountTypes={this.state.accountTypes}
                      vatTypeSelector={this.state.vatTypeSelector}
                      vatTypeSelections={vatTypeSelections}
                      wTaxRates={this.state.wTaxRates}
                      handleChangeRequestField={this.handleChangeRequestField}
                      handleChangeProjectClassValue={
                        this.handleChangeProjectClassValue
                      }
                      getTaxRate={this.handleWTaxRate}
                      addProjectClass={this.addProjectClass}
                      handleSubmitNonPo={this.handleSubmitNonPo}
                      handleDraftNonPo={this.handleDraftNonPo}
                      checkStateValue={this.checkStateValue}
                      file={this.state.file}
                      vendorLists={this.state.vendorLists}
                      projectLists={this.state.projectLists}
                      //this is
                      requestId={this.state.requestId}
                      //
                      handleRemoveProjectClass={this.handleRemoveProjectClass}
                      addedProjectClass={this.state.addedProjectClass}
                      changed={this.onChangedHandler}
                      onBlurNumber={this.onBlurNumber}
                      handleSubmitDraft={this.handleSubmitDraft}
                      handleNavigateBack={this.handleNavigateBack}
                    />
                  </animated.div>
                ))
              }
            </Transition>
          </div>
          {/* END OF FORM */}
        </div>
      </form>

      //   )}
      // </CrfContext.Consumer>
    );
  }
}

const dark = {
  color: "black",
};

export default NonPoItems;
